import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const interests = [{
  name: 'Private Cinema',
  color: 'cinema',
  hex: '#6366F1'
}, {
  name: 'Whole Home Audio',
  color: 'music',
  hex: '#EC4899'
}, {
  name: 'Smart Lighting',
  color: 'social',
  hex: '#F59E0B'
}, {
  name: 'Full Automation',
  color: 'relax',
  hex: '#10B981'
}, {
  name: 'Gaming Setup',
  color: 'gaming',
  hex: '#8B5CF6'
}, {
  name: 'Wellness Spaces',
  color: 'music',
  hex: '#EC4899'
}];
export function ConsultationCTA() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedInterests, setSelectedInterests] = useState<string[]>([]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  const toggleInterest = (name: string) => {
    setSelectedInterests(prev => prev.includes(name) ? prev.filter(i => i !== name) : [...prev, name]);
  };
  return <section id="consult" className="py-32 bg-obsidian relative border-t border-graphite" data-id="element-190">
      <div className="max-w-4xl mx-auto px-6" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-192">
          <h2 className="text-display font-serif text-platinum mb-4" data-id="element-193">
            Let's design your home.
          </h2>
          <p className="text-silver text-lg max-w-2xl mx-auto" data-id="element-194">
            Book a private consultation. No spec sheets. No pressure. Just a
            conversation about how your home should feel.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-carbon p-8 md:p-12 rounded-2xl border border-graphite relative overflow-hidden" data-id="element-195">
          {isSubmitted ? <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="flex flex-col items-center justify-center py-16 text-center" data-id="element-196">
              <div className="w-16 h-16 rounded-full bg-gradient-to-r from-cinema to-music flex items-center justify-center mb-6" data-id="element-197">
                <CheckIcon className="w-8 h-8 text-white" data-id="element-198" />
              </div>
              <h3 className="text-title font-serif text-platinum mb-2" data-id="element-199">
                Request Received
              </h3>
              <p className="text-silver" data-id="element-200">
                Our design team will be in touch within 24 hours to schedule
                your private consultation.
              </p>
            </motion.div> : <form onSubmit={handleSubmit} className="space-y-6 relative z-10" data-id="element-201">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-202">
                <div data-id="element-203">
                  <label className="block text-xs uppercase tracking-widest text-silver mb-2" data-id="element-204">
                    Full Name
                  </label>
                  <input required type="text" className="w-full bg-void border border-graphite rounded-lg px-4 py-3 text-platinum focus:border-cinema focus:outline-none transition-colors" data-id="element-205" />
                </div>
                <div data-id="element-206">
                  <label className="block text-xs uppercase tracking-widest text-silver mb-2" data-id="element-207">
                    Email Address
                  </label>
                  <input required type="email" className="w-full bg-void border border-graphite rounded-lg px-4 py-3 text-platinum focus:border-music focus:outline-none transition-colors" data-id="element-208" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-209">
                <div data-id="element-210">
                  <label className="block text-xs uppercase tracking-widest text-silver mb-2" data-id="element-211">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full bg-void border border-graphite rounded-lg px-4 py-3 text-platinum focus:border-social focus:outline-none transition-colors" data-id="element-212" />
                </div>
                <div data-id="element-213">
                  <label className="block text-xs uppercase tracking-widest text-silver mb-2" data-id="element-214">
                    Home Size
                  </label>
                  <select className="w-full bg-void border border-graphite rounded-lg px-4 py-3 text-platinum focus:border-relax focus:outline-none transition-colors appearance-none" data-id="element-215">
                    <option data-id="element-216">Under 4,000 sq ft</option>
                    <option data-id="element-217">4,000 - 8,000 sq ft</option>
                    <option data-id="element-218">8,000 - 15,000 sq ft</option>
                    <option data-id="element-219">15,000+ sq ft</option>
                  </select>
                </div>
              </div>

              <div data-id="element-220">
                <label className="block text-xs uppercase tracking-widest text-silver mb-3" data-id="element-221">
                  Primary Interest
                </label>
                <div className="flex flex-wrap gap-3" data-id="element-222">
                  {interests.map(interest => {
                const isSelected = selectedInterests.includes(interest.name);
                return <button key={interest.name} type="button" onClick={() => toggleInterest(interest.name)} className={`px-4 py-2 rounded-full border transition-colors text-sm ${isSelected ? `bg-${interest.color}/10 text-${interest.color}` : 'border-graphite text-silver hover:border-silver/50'}`} style={isSelected ? {
                  borderColor: interest.hex,
                  color: interest.hex
                } : {}} data-id="element-223">
                        {interest.name}
                      </button>;
              })}
                </div>
              </div>

              <div className="pt-6 text-center" data-id="element-224">
                <button type="submit" className="relative px-12 py-4 rounded-full font-medium tracking-wide w-full md:w-auto group overflow-hidden" data-id="element-225">
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-cinema to-music group-hover:opacity-80 transition-opacity duration-300" data-id="element-226"></span>
                  <span className="relative text-white" data-id="element-227">
                    Start Your Journey
                  </span>
                </button>
              </div>
            </form>}
        </motion.div>
      </div>
    </section>;
}